<template>
    <lesson-list 
        :data="data" 
        :canEdit="false"
        @out="handleClick"
        >
        <el-tag size="small" slot="top" v-for="item in screen" :key="item.value" :type="item.value === activeStatus ? 'default' : 'info'" @click="beforeChange(item.value)">{{item.text}}</el-tag>
    </lesson-list>
</template>

<script>
import lessonList from './lesson-list'
export default {
    data () {
        return {
            activeStatus: '1',
            screen: [
                { value: '1', text: '上课中' },
                { value: '2', text: '已结课' }
            ]
        }
    },
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
        lessonList
    },
    methods: {
        handleClick(uid) {
            this.$emit('out', uid)
        },
        beforeChange (val) {
            this.activeStatus = val
            this.$emit('status-change', val)
        }
    }
}
</script>
